import { useState } from "react";
import { useData, useDispatch } from "./DataContext.js";
import { getSimParam } from "./utils.js";

import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import InputGroup from "react-bootstrap/InputGroup";

import { PlusLg } from "react-bootstrap-icons";

import CardTitle from "./CardTitle.js";
import StudentCard from "./StudentCard.js";
import GroupCode from "./GroupCode.js";
/* import GroupModal from "./GroupModal.js"; */
import ButtonGrid from "./ButtonGrid.js";

export default function GroupCard (props)
{
    const [name, setName] = useState("");
    /* const [info, setInfo] = useState(false); */

    const gData = useData();
    const gDispatch = useDispatch();

    const personal = getSimParam(gData, "personalGroups");

    const groupID = props.groupID;
    const group = gData.group[groupID];
    const groupType = group.type;
    const groupTitle = group.title;
    const groupDescription = group.description;
    const groupCode = group.code;
    const selected = group.selected === 1;

    let groupTypeStr = "";
    switch (groupType)
    {
	case "delegation" : groupTypeStr = "Délégation"; break;
	case "lobby" : groupTypeStr = "Lobby"; break;
	case "media" : groupTypeStr = "Média"; break;
	case "admin" : groupTypeStr = "Présidence"; break;
	default: groupTypeStr = "";
    }

    const studentList = Object.entries(gData.student)
			      .filter(([id, student]) => student.groupID === groupID)
			      .map(([id, student]) => (<StudentCard key={id} studentID={id}/>));


    /* function showInfo (e) { e.preventDefault(); setInfo(true); }
     * function hideInfo () { setInfo(false); } */

    function selectGroup (e) { e.preventDefault(); gDispatch({ type: "upload", table: "group", id: groupID, data: { selected: 1 } }); }
    function unselectGroup (e) { e.preventDefault(); gDispatch({ type: "upload", table: "group", id: groupID, data: { selected: 0 } }); }

    function handleNameChange (e) { setName(e.target.value); }
    function handleNewStudent (e)
    {
	e.preventDefault();
	if (name !== "")
	{
	    gDispatch({ type: "upload", table: "student", id: null, data: { simID: gData.simID, groupID, name } });
	    setName("");
	}
    }
    
    return (
	<>
	    <Card className="shadow-sm" style={{ width: 500 }}>
		<Card.Header>
		    <CardTitle subtitle={groupTypeStr} title={groupType !== "admin" ? groupTitle : ""}/>
		</Card.Header>
		<Card.Body className="d-flex flex-column gap-3">
		    <div>
			<div className="text-uppercase text-muted small">Description</div>
			<div>{groupDescription}</div>
		    </div>
		    {selected && (
			<div className="d-flex justify-content-between">
			    <div>
				<div className="text-uppercase text-muted small">Code SIM</div>
				<div><GroupCode code={groupCode}/></div>
			    </div>
			    <div>
				<div className="text-uppercase text-muted small">Lien d'accès à la SIM</div>
				<div><GroupCode code={groupCode} fulllink/></div>
			    </div>
			</div>
		    )}
		    {selected && (
			<div>
			    <div className="text-uppercase text-muted small">Liste des membres</div>
			    {studentList.length > 0 ? (
				<div className="d-flex flex-wrap gap-2 mt-1">{studentList}</div>
			    ) : (
				<div className="text-danger">Ce groupe ne contient aucun membre.</div>
			    )}
			</div>
		    )}
		</Card.Body>
		<Card.Footer className="d-flex flex-column gap-2">
		    <ButtonGrid>
			<ButtonGrid.Left>
			    {(personal && selected && groupType !== "admin") && (<Button variant="outline-secondary" size="md" onClick={unselectGroup}>Mettre en réserve</Button>)}
			    {(personal && ! selected) && (<Button variant="outline-secondary" size="md" onClick={selectGroup}>Ajouter à la liste</Button>)}
			</ButtonGrid.Left>
			<ButtonGrid.Right>
			    {selected && (
				<Form
				    onSubmit={handleNewStudent}
				>
				    <InputGroup>
					<Form.Control
					    type="text"
					    required
					    placeholder="Ajouter un membre"
					    value={name}
					    onChange={handleNameChange}
					    size="md"
					    style={{ width: 180 }}
					/>
					<Button variant="primary" size="md" type="submit"><PlusLg/></Button>
				    </InputGroup>
				</Form>
			    )}
			</ButtonGrid.Right>
		    </ButtonGrid>
		</Card.Footer>
	    </Card>
	    {/* <GroupModal show={info} hide={hideInfo} groupID={groupID}/> */}
	</>
    );
}
